function AdviceTemplatesNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" id="advice-Templates">
      <path stroke="#8E33FF" strokeLinecap="round" strokeWidth="1.5" d="M11.667 17.5h-8a2 2 0 01-2-2v-11a2 2 0 012-2h12.666a2 2 0 012 2v7.167"></path>
      <path
        stroke="#8E33FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M1.667 5.833h16.666M4.167 4.175l.008-.01M6.667 4.175l.008-.01M9.167 4.175l.008-.01M16.25 18.334v-5m0 0l-2.083 2.083m2.083-2.083l2.083 2.083"
      ></path>
    </svg>
  );
}

export default AdviceTemplatesNavIcon;
